import React from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  Button,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import { useNavigate } from "react-router-dom";
import Cloud from "../../Assets/Cloud.gif"
import CM1 from "../../Assets/CM1.jpg"
import CM2 from "../../Assets/CM2.jpg"
import CM3 from "../../Assets/CM3.jpg"

const CloudMigration = () => {
  const navigate = useNavigate();

  return (

    <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 6, md: 8 } }}>
      {/* Hero Section */}
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 5 },
          mb: 6,
          background: "#e3f2fd",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h3"
          gutterBottom
          sx={{ fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" } }}
        >
          Cloud Migration Services
        </Typography>
        <Typography
          variant="h6"
          color="textSecondary"
          sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }}
        >
          Seamless migration of your infrastructure, applications, and data to the cloud.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={() => navigate("/contact")}
        >
          Get Started
        </Button>

      </Paper>



      <Box className="gif-container" sx={{ flexShrink: 0, ml: -2 }}>
        <img src={Cloud} alt="Cloud Migration" className="cloud-gif" />
      </Box>

      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontSize: { xs: "1.75rem", sm: "2rem" } }}
        >
          What We Offer
        </Typography>
        <Typography
          variant="body1"
          color="#d1d5db"
          sx={{ textAlign: "justify", maxWidth: "900px", mx: "auto" }}
        >
          Our cloud migration services encompass everything from strategic planning to post-migration optimization.
          We offer tailored solutions including cloud readiness assessments, migration roadmaps, infrastructure modernization,
          and hands-on execution to ensure a smooth transition. Our team ensures minimal downtime, data integrity,
          and full support throughout the migration journey and beyond.
        </Typography>
      </Box>

      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontSize: { xs: "1.75rem", sm: "2rem" } }}
        >
          What is Cloud Migration?
        </Typography>
        <Typography
          variant="body1"
          color="#d1d5db"
          sx={{ textAlign: "justify", maxWidth: "900px", mx: "auto" }}
        >
          Cloud migration is the process of moving digital business operations into the cloud. It involves transferring data,
          applications, and IT processes from on-premises infrastructure to a cloud-based environment, which provides better
          scalability, performance, and cost-efficiency.
        </Typography>
      </Box>

      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontSize: { xs: "1.75rem", sm: "2rem" },
            py: 4,
          }}
        >
          Key Benefits
        </Typography>
        <Grid container spacing={4}>
          {[
            {
              title: "Scalability",
              description: "Easily scale up or down based on your business needs.",
            },
            {
              title: "Cost Efficiency",
              description: "Reduce capital expenditure with pay-as-you-go models.",
            },
            {
              title: "Business Continuity",
              description: "Ensure high availability and disaster recovery.",
            },
            {
              title: "Performance",
              description: "Boost application performance with advanced cloud infrastructure.",
            },
          ].map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  height: "100%",
                  backgroundColor: "#2196f3",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  p: 2,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" color="inherit">
                    {benefit.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontSize: { xs: "1.75rem", sm: "2rem" },
            py: 4,
          }}
        >
          Our Migration Process
        </Typography>
        <Grid container spacing={4}>
          {[
            "Assessment and Planning",
            "Infrastructure Setup",
            "Application Migration",
          ].map((step, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
                elevation={3}
                sx={{
                  p: { xs: 3, sm: 4 },
                  color: "#fff",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  backgroundColor: "#1c1c1c",

                }}
              >
                <Typography variant="h6" gutterBottom>
                  Step {index + 1}
                </Typography>
                <Typography variant="subtitle1">{step}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ mt: { xs: 8, sm: 10 }, mb: 5 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontSize: { xs: "1.75rem", sm: "2rem" },
            mt: 6,
            py: 4,
          }}
        >
          Use Cases
        </Typography>
        <Grid container spacing={4}>
          {[
            {
              title: "Legacy System Modernization",
              image: CM1,
              description: "Update and migrate your outdated systems to modern cloud environments.",
            },
            {
              title: "Data Center Exit",
              image: CM3,
              description: "Move your workloads to the cloud and shut down physical data centers.",
            },
            {
              title: "Disaster Recovery",
              image: CM2,
              description: "Set up resilient backup and recovery in the cloud.",
            },
          ].map((useCase, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  backgroundColor: "#1c1c1c",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardMedia
                  component="img"
                  image={useCase.image}
                  alt={useCase.title}
                  sx={{ height: { xs: 150, sm: 200 }, objectFit: "cover" }}
                />
                <CardContent>
                  <Typography variant="h6">{useCase.title}</Typography>
                  <Typography variant="body2" color="inherit">
                    {useCase.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 5 },
          textAlign: "center",
          backgroundColor: "#e8f5e9",
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontSize: { xs: "1.75rem", md: "2rem" } }}
        >
          Ready to Migrate to the Cloud?
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}
        >
          Contact our cloud experts to get a free consultation.
        </Typography>
        <Button variant="contained" color="success" onClick={() => navigate("/contact")}
        >
          Contact Us
        </Button>
      </Paper>
    </Container>
  );
};

export default CloudMigration;
